import axios from "utils/axios";

class TimelineService {
  getTimeLineMessageTemplates() {
    return axios.get(`/user/template-message`);
  }
  getTimeLineVideos(teamId, category) {
    return axios.get(`/user/team/${teamId}/assets/video/${category}`);
  }

  getRiddle(teamId, userId) {
    return axios.get(`/wellness/riddle/get-team-riddle/${teamId}`, {
      headers: {
        "Accept-version": "2.0",
        "Cache-Control": "no-cache, private",
        userId: userId,
      },
    });
  }

  submitRiddleAnswer(payload, userId) {
    return axios.post(`/wellness/riddle/add-response`, payload, {
      headers: {
        "Accept-version": "2.0",
        "Cache-Control": "no-cache, private",
        userId: userId,
      },
    });
  }

  createRating(postId, companyId, rating) {
    let data = {
      postId: postId,
      companyId: companyId,
      rating: rating,
    };

    return axios.post(`/wellness/post/rating`, data, {
      headers: {
        "Accept-version": "2.0",
        "Cache-Control": "no-cache, private",
      },
    });
  }
}

export default new TimelineService();
